export const incomeSlab = [
  {
    code: 'BL1-LAC',
    name: 'Below 1 Lac'
  },
  {
    code: '1-5-LAC',
    name: '1-5 Lac'
  },
  {
    code: '5-10-LAC',
    name: '5-10 Lac'
  },
  {
    code: '10-25-LAC',
    name: '10-25 Lac'
  },
  {
    code: '>25-LAC',
    name: '> 25 Lac'
  }
]
